var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panel",
    [
      _c("v-expansion-panel-header", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var open = ref.open
              return [
                _c(
                  "v-row",
                  { attrs: { "no-gutters": "" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "text--secondary", attrs: { cols: "12" } },
                      [
                        _c(
                          "v-fade-transition",
                          { attrs: { "leave-absolute": "" } },
                          [
                            open
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          absolute: "",
                                          dark: "",
                                          fab: "",
                                          center: "",
                                          right: "",
                                          color: "pink",
                                        },
                                        on: { click: _vm.removeAltriPresale },
                                      },
                                      [_c("v-icon", [_vm._v("mdi-minus")])],
                                      1
                                    ),
                                    _c("span", [
                                      _vm._v("Dettaglio Altri Costi Presale"),
                                    ]),
                                  ],
                                  1
                                )
                              : _c(
                                  "v-row",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { "no-gutters": "" },
                                  },
                                  [
                                    _c("v-col", { attrs: { cols: "2" } }, [
                                      _vm._v(
                                        "Costo Atteso: " +
                                          _vm._s(
                                            _vm.CostoAttesoAltriPresale + "€" ||
                                              "Non impostato"
                                          )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "v-expansion-panel-content",
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "2", md: "2" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      prefix: "€",
                      label: "Costo Atteso",
                      type: "number",
                    },
                    model: {
                      value: _vm.CostoAttesoAltriPresale,
                      callback: function ($$v) {
                        _vm.CostoAttesoAltriPresale = $$v
                      },
                      expression: "CostoAttesoAltriPresale",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "5" } },
                [
                  _c("v-textarea", {
                    attrs: {
                      rows: "1",
                      label: "Descrizione",
                      rules: [
                        function (v) {
                          return !!v || "Item is required"
                        },
                      ],
                    },
                    model: {
                      value: _vm.DescrizioneAltriPresale,
                      callback: function ($$v) {
                        _vm.DescrizioneAltriPresale = $$v
                      },
                      expression: "DescrizioneAltriPresale",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }